export default __webpack_public_path__ + "close-watchlist-86996e53869ad128defa275c6e04c1e1.svg";